<template>
    <div>
        <h1 v-if="selectedRate" id="rate-title">{{selectedRate.hebrewName}}</h1>

        <BlockUI :blocked="isLoading || !isSelectAll">
            <ScrollPanel style="width: 98%; height: 70vh">
                <table class="grade " :id="selectedReportType && selectedReportType.value">
                    <tr class="header">
                        <th>
                            שם התלמיד
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            {{ selectedReportType.value === TOPICS_TYPE ? 'ממוצע' : 'כמות' }}

                        </th>
                        <th v-if="selectedOldReportName && selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            ציון קודם
                        </th>

                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            ציון
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value === RATED_TYPE">
                            דירוג
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value === RATED_TYPE">
                             דירוג קודם
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            תיאור
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            תיאור קודם
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value === NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            הערכת מחנך
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE">
                            מדווח
                        </th>
                        <th v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE">
                            עדכון
                        </th>
                    </tr>

                    <tr style="height:20px" v-for="(pupil, index) in userPupils" :key="pupil.id">
                        <!--                    <div>-->
                        <th
                                style="width: 15%"
                        >
                            {{ pupil.firstname }} {{ pupil.lastname }}
                        </th>
                        <th
                                style="width: 5%"
                                v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            {{ gradeStatistics[pupil.id] }}
                        </th>
                        <td
                                style="width: 5%"
                                v-if="selectedOldReportName && selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            {{ oldScore[pupil.id] && oldScore[pupil.id].score }}

                        </td>
                        <td
                                style="width: 10%"
                                v-if=" selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">

                            <AutoComplete
                                    style="width: 100%"
                                    contenteditable="true"
                                    :id="`${index}indexScore`"
                                    placeholder="ציון"
                                    v-model="score[pupil.id]"
                                    :suggestions="filteredOptionsScore"
                                    @complete="searchScoreOption($event)"
                                    @input="inputData($event, pupil)"

                                    :dropdown="true"
                                    forceSelection
                            ></AutoComplete>
                            <!--                                                                <input-text :id="`${index}indexScore`" placeholder="ציון" @change="inputData($event, pupil)"-->
                            <!--                                                                            v-model="score[pupil.id]"/>-->
                        </td>
                        <td
                                style="width: 40%"
                                v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            <AutoComplete
                                    :id="`${index}indexDesc`"
                                    style="width:98%"
                                    contenteditable="true"
                                    @complete="searchDescriptionOption($event, pupil)"
                                    placeholder="הערה"
                                    @item-select="inputData($event, pupil)"
                                    @clear="inputData($event, pupil)"
                                    v-model="description[pupil.id]"
                                    :suggestions="filteredOptionsDescription"
                                    :dropdown="true"

                            ></AutoComplete>
                            <!--                                <Textarea-->
                            <!--                                        rows="1"-->
                            <!--                                        style="width:98%"-->

                            <!--                                        :id="`${index}indexDesc`"-->
                            <!--                                        placeholder="הערה"-->
                            <!--                                        @input="inputData($event, pupil)"-->
                            <!--                                        v-model="description[pupil.id]"/>-->

                        </td>

                        <!--                        RATE-->
<!--                        :tooltip="selectedRate.options && selectedRate.options.split(',')"-->
                        <td style="width: 10%" v-if="selectedReportType && selectedReportType.value === RATED_TYPE">
                            <Rating @input="inputData($event, pupil)" :tooltip="selectedRate.options.split(',')" :stars="selectedRate.starsCount"
                                    v-model="score[pupil.id]" :cancel="true"/>
                        </td>

<!--                                                RATE OLD-->
                        <td                                 style="width: 10%"
                                                            v-if="selectedReportType && selectedReportType.value === RATED_TYPE">
                            <Rating @input="inputData($event, pupil)" readonly disabled  :stars="selectedRate.starsCount"
                                    v-model="oldScore[pupil.id] && oldScore[pupil.id].score" :cancel="false"/>
                        </td>


                        <td v-if="selectedReportType && selectedReportType.value === NOTE_TYPE">
                            <AutoComplete
                                    :id="`${index}indexDesc`"
                                    contenteditable="true"
                                    @complete="searchDescriptionOption($event, pupil)"
                                    placeholder="הערכת מחנך"
                                    @item-select="inputData($event, pupil)"
                                    @clear="inputData($event, pupil)"
                                    v-model="summary[pupil.id]"
                                    :suggestions="filteredOptionsDescription"
                                    :dropdown="true"

                            ></AutoComplete>
                            <!--                                        <Textarea-->
                            <!--                                                rows="1"-->
                            <!--                                                style="width:98%"-->
                            <!--                                                placeholder="הערכת מחנך"-->
                            <!--                                                @change="inputData($event, pupil)"-->
                            <!--                                                v-model="summary[pupil.id]"/>-->
                        </td>
                        <td
                                style="width: 5%"
                                v-if="selectedOldReportName && selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE &&  selectedReportType.value !== RATED_TYPE">
                            <Button v-if="oldScore[pupil.id] && oldScore[pupil.id].description" icon="pi pi-eye"
                                    class="p-col-1 p-button-rounded p-button-secondary p-button-text"
                                    v-tooltip.top="oldScore[pupil.id].description"></Button>

                        </td>
                        <td
                                style="width: 10%"
                                v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE">
                            {{ techers[pupil.id] ? getFullName(techers[pupil.id]) : '---' }}
                        </td>
                        <td
                                style="width: 15%"
                                v-if="selectedReportType && selectedReportType.value !== NOTE_TYPE && selectedReportType.value !== PRESENCES_TYPE">
                            {{ lastUpdate[pupil.id] ? getDate(lastUpdate[pupil.id]) : '---' }}
                        </td>
                    </tr>
                </table>
            </ScrollPanel>
        </BlockUI>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {postData, getData} from './gradeReport'

import Vue from "vue";
import {getUserFullName} from "@/utils/parseObj";
import {dateToHebrewAndTime, dateToOnlyHebrewAndTime} from "@/utils/hebrewDateFormat";
import Service from "@/service/Service";
import {getAllDescriptions} from "@/views/report/Report";
import {putTest} from "@/views/tests/scoreTest/gradeTest";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"
const RATED_TYPE = "ratedScores"


export default {
    name: "pupils-list",
    props: {
        selectedGrade: {
            type: Object
        },
        selectedSubject: {
            type: Object
        },
        selectedRate: {
            type: Object
        },
        selectedReportName: {
            type: Object
        },
        selectedOldReportName: {
            type: Object
        },
        selectedReportType: {
            type: Object
        }
    },
    components: {},
    mounted() {
        this.service = new Service();
    },
    data() {
        return {
            score: null,
            oldScore: null,
            description: {},
            techers: {},
            summary: {},
            lastUpdate: {},
            isLoading: true,
            PRESENCES_TYPE: PRESENCES_TYPE,
            BEHAVIORS_TYPE: BEHAVIORS_TYPE,
            TOPICS_TYPE: TOPICS_TYPE,
            NOTE_TYPE: NOTE_TYPE,
            RATED_TYPE: RATED_TYPE,
            indexScore: 0,
            indexDesc: 0,
            componentUpdate: 0,
            descriptions: [],
            topicsGradeStatistics: {},
            behaviorsGradeStatistics: {},
            presencesGradeStatistics: {},
            topicsOptions: [
                'טוב מאוד',
                'כמעט טוב מאוד',
                'טוב',
                "כמעט טוב",
                "מספיק",
                "כמעט מספיק",
                "לא מספיק",
                " ",
            ],
            behaviorOptions: [
                'א',
                'א-',
                'א-ב',
                'ב',
                'ב-',
                'ב-ג',
                'ג',
            ],
            filteredTopicsOptions: null,
            filteredOptionsScore: [],
            filteredOptionsDescription: [],

        }
    },
    created() {
        this.getDataForGrade()
        this.getAllDescriptions()
        this.cleanAllData()
    },
    watch: {

        selectedRate(a, b) {
            this.getDataForGrade()
            this.cleanAllData()
        },
        selectedReportName(a, b) {
            this.getDataForGrade()
            this.cleanAllData()
        },
        selectedOldReportName(a, b) {
            this.getOldDataForGrade()
            this.cleanOldAllData()
        }, selectedReportType(a, b) {
            // if (b !== null) {
            this.getOldDataForGrade()
            this.cleanOldAllData()
            this.getDataForGrade()
            this.cleanAllData()
            // }
        }, selectedSubject(a, b) {
            // if (b !== null) {
            this.getOldDataForGrade()
            this.cleanOldAllData()
            this.getDataForGrade()
            this.cleanAllData()
            // }
        }, selectedGrade(a, b) {
            // if (b !== null) {
            this.getOldDataForGrade()
            this.cleanOldAllData()
            this.getDataForGrade()
            this.cleanAllData()
            // }
        }
    },
    methods: {

        async getAllDescriptions() {
            try {
                const {data} = await getAllDescriptions()
                this.descriptions = data
            } catch (e) {

            }
        },
        searchTopicScoreOption(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredTopicsOptions = [...this.topicsOptions];
                } else {
                    this.filteredTopicsOptions = this.topicsOptions
                        .filter((option) => {
                            return option.startsWith(event.query);
                        });
                }
            }, 250);
        },
        searchScoreOption(event, pupil) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    if (this.selectedReportType.value === BEHAVIORS_TYPE) {
                        this.filteredOptionsScore = [...this.behaviorOptions];

                    } else if (this.selectedReportType.value === TOPICS_TYPE) {
                        this.filteredOptionsScore = [...this.topicsOptions];
                    }
                } else {
                    if (this.selectedReportType.value === BEHAVIORS_TYPE) {
                        this.filteredOptionsScore = this.behaviorOptions
                            .filter((option) => {
                                return option.startsWith(event.query);
                            });
                    } else if (this.selectedReportType.value === TOPICS_TYPE) {
                        this.filteredOptionsScore = this.topicsOptions
                            .filter((option) => {
                                return option.startsWith(event.query);
                            });
                    }
                }
            }, 100);
        },
        searchDescriptionOption(event, pupil) {
            this.inputData(event, pupil)
            // if (this.selectedReportType.value === NOTE_TYPE){
            //     this.selectedSubject = {}
            //     this.selectedSubject.id = NOTE_TYPE
            // }
            // console.log(".this.selectedSubject.id",this.selectedSubject.id)
            // console.log(".this..descriptions.",this.descriptions)

            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredOptionsDescription = this.descriptions
                        .filter(desc => desc.subjectType === this.selectedReportType.value)
                        .filter(descType => descType.subjectId === (
                            this.selectedReportType.value !== NOTE_TYPE ?
                                this.selectedSubject.id :
                                NOTE_TYPE
                        ))
                        .map(descFilter => descFilter.description)
                } else {
                    this.filteredOptionsDescription = this.descriptions
                        .filter(desc => desc.subjectType === this.selectedReportType.value)
                        .filter(descType => descType.subjectId === (
                            this.selectedReportType.value !== NOTE_TYPE ?
                                this.selectedSubject.id :
                                NOTE_TYPE
                        ))
                        .map(descFilter => descFilter.description).filter((option) => {
                            return option.startsWith(event.query);
                        });

                }
            }, 100);
        },
        aa(type, isPrevious) {
            isPrevious ? this[type]-- : this[type]++
            document.getElementById(`${this[type]}${type}`).focus();

        },
        getFullName(userId) {
            return getUserFullName(userId)
        },
        getDate(dateLong) {
            return dateToOnlyHebrewAndTime(dateLong)
        },
        cleanAllData() {
            this.score = {}
            this.description = {}
            this.techers = {}
            this.lastUpdate = {}
            this.summary = {}
        },
        cleanOldAllData() {
            this.oldScore = {}
        },
        async getStatistics() {
            return new Promise(async (resolve, reject) => {
                try {
                    switch (this.selectedReportType.value) {
                        case  TOPICS_TYPE:
                            const testStatistics = await this.service.getTotalTestByGradeAndSubject(this.selectedGrade.id, this.selectedSubject.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                            this.topicsGradeStatistics = {}
                            testStatistics.forEach(item => {
                                this.topicsGradeStatistics[item.id] = item.avg
                            })
                            resolve()
                            break;
                        case  BEHAVIORS_TYPE:
                            const trackStatistics = await this.service.getTotalTrackByGradeAndSubject(this.selectedGrade.id, this.selectedSubject.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                            this.behaviorsGradeStatistics = {}
                            trackStatistics.forEach(item => {
                                this.behaviorsGradeStatistics[item.id] = item.count
                            })
                            resolve()
                            break;

                        case  PRESENCES_TYPE:
                            const data = await this.service.getTotalPresenceByGradeAndSubject(this.selectedGrade.id, this.selectedSubject.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                            this.presencesGradeStatistics = {}
                            data.forEach(item => {
                                this.presencesGradeStatistics[item.id] = item.count
                            })
                            resolve()
                            break;
                        case  NOTE_TYPE:
                            resolve()
                            break;
                        default:
                            resolve()

                    }

                } catch (e) {
                    reject()
                }
            })
        },
        async getDataForGrade() {
            this.isLoading = true
            await Promise.all([
                this.getReports(),
                this.getStatistics()
            ])
            this.isLoading = false


        },
        async getOldDataForGrade() {
            console.log("this.selectedReportType.value" , this.selectedReportType.value)
            if (this.selectedReportType.value !== NOTE_TYPE){
                this.isLoading = true
                await Promise.all([
                    this.getOldReports(),
                ])
                this.isLoading = false
            }

        },
        async getOldReports() {
            return new Promise(async (resolve, reject) => {
                try {
                    const reportName = this.selectedOldReportName.id

                    const {data} = await getData(reportName, this.selectedGrade.id)
                    data.forEach((obj) => {
                            const type = this.selectedReportType.value
                        let id = this.selectedSubject.id
                        if (this.selectedReportType.value === RATED_TYPE){
                            id = this.selectedRate.id
                        }

                        if (obj?.[type]?.[id]) {
                                // if (obj?.[type]?.[this.selectedSubject.id].score) {
                                const scoreA = {
                                    score: obj?.[type]?.[id]?.score,
                                    description: obj?.[type]?.[id]?.description
                                }
                            console.log("scoreA", scoreA)
                                const scoreFull = this.oldScore
                                scoreFull[obj.pupil] = scoreA
                                this.oldScore = Object.assign({}, scoreFull);
                            console.log("oldScore", this.oldScore)
                                // }
                            }
                        }
                    )
                    resolve()
                } catch (e) {
                    console.log(e)
                    reject()
                }
            })
        },
        async getReports() {
            return new Promise(async (resolve, reject) => {
                try {
                    const reportName = this.selectedReportName.id

                    const {data} = await getData(reportName, this.selectedGrade.id)
                    let id = this.selectedSubject?.id
                    if (this.selectedReportType.value === RATED_TYPE){
                        id = this.selectedRate.id
                    }
                    data.forEach((obj) => {
                            const type = this.selectedReportType.value

                            if (obj?.[type]?.[id]) {
                                if (obj?.[type]?.[id].score) {
                                    const scoreA = obj?.[type]?.[id].score
                                    const scoreFull = this.score
                                    scoreFull[obj.pupil] = scoreA
                                    this.score = Object.assign({}, scoreFull);
                                }

                                if (obj?.[type]?.[id].description) {
                                    const scoreA = obj?.[type]?.[id].description
                                    const scoreFull = this.description
                                    scoreFull[obj.pupil] = scoreA
                                    this.description = Object.assign({}, scoreFull);
                                }

                                if (obj?.[type]?.[id].user) {
                                    const scoreA = obj?.[type]?.[id].user
                                    const scoreFull = this.techers
                                    scoreFull[obj.pupil] = scoreA
                                    this.techers = Object.assign({}, scoreFull);
                                }

                                if (obj?.[type]?.[id].ts) {
                                    const scoreA = obj?.[type]?.[id].ts
                                    const scoreFull = this.lastUpdate
                                    scoreFull[obj.pupil] = scoreA
                                    this.summary = Object.assign({}, scoreFull);
                                }
                            }

                            const summaryReport = obj?.summaryReport
                            const summaryFull = this.summary
                            summaryFull[obj.pupil] = summaryReport
                            this.summary = Object.assign(
                                {},
                                summaryFull,
                            );
                        }
                    )
                    resolve()
                } catch (e) {
                    console.log(e)
                    reject()
                }
            })
        },
        inputDataDropDown(input, pupil) {
            const full = this.score
            this.score[pupil.id] = input
            full[pupil.id] = input
            this.inputData(input, pupil)
        },
        async inputData(input, pupil) {
            let id = this.selectedSubject?.id
            if (this.selectedReportType.value === RATED_TYPE){
                id = this.selectedRate?.id
            }

            const obj = {
                "name": this.selectedReportName.id,
                "pupil": pupil.id,
                "typeOfScore": this.selectedReportType.value,
                "scoresToUpdate": {
                    [id]: {
                        "score": this.score[pupil.id],
                        "description": this.description[pupil.id],
                        "user": this.user.id,
                        "ts": new Date().getTime()
                    }
                },
                "summaryReport": this.summary[pupil.id]
            }
            this.lastUpdate[pupil.id] = new Date().getTime()
            this.techers[pupil.id] = this.user.id

            // this.componentUpdate++
            try {
                await postData(obj)
                this.$vs.notification({color: "success", position:"right-left", duration : 500 , loading:true, width: '10%'});

            } catch (e) {
                console.error(e)
                this.openNotification(
                    "danger",
                    `אופס התרחשה שגיאה`,
                    e
                );
            }
        },
        openNotification(color, title, text, position = "right-left", duration = 3000 ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        getDescriptionsOptions() {
            return ["cc", "fff"]
            // return  this.descriptions
            //     .filter(desc => desc.subjectType === this.selectedReportType.value)
            //     .filter(descType => descType.subjectId === this.selectedSubject.id)
            //     .map(descFilter => descFilter.description)
        },
        async inputSummary(input, pupil) {
            const obj = {
                "name": this.selectedReportName.id,
                "pupil": pupil.id,
                "typeOfScore": this.selectedReportType.value,
                "scoresToUpdate": {
                    [a]: {
                        "score": this.score[pupil.id],
                        "description": this.description[pupil.id],
                        "user": this.user.id,
                        "ts": new Date().getDate()
                    }
                },
                summaryReport: this.summary[pupil.id]
            }


        },
    },

    computed: {
        isSelectAll(){
            return this.selectedReportName !== null
        },
        gradeStatistics() {
            switch (this.selectedReportType.value) {
                case  TOPICS_TYPE:
                    return this.topicsGradeStatistics
                case  BEHAVIORS_TYPE:
                    return this.behaviorsGradeStatistics


                case  PRESENCES_TYPE:
                    return this.presencesGradeStatistics
                case  NOTE_TYPE:
                    return {}


                default:
                    return {}

            }
        },
        scoreOptions() {
            return behaviorOptions
        },
        ...mapState(["intro", "pupils", "user", "gradeOptions", "reportRatings"]),
        userPupils() {
            return this.pupils?.filter((p) => p.grade?.id ===
                this.selectedGrade?.id);
        }
    }
}
</script>

<style scoped>
>>> .p-autocomplete {
    width: 100%
}

.grade {
    width: 100%;
}

.grade td, .grade th {
    padding: 8px;
}

.grade tr:nth-child(even) {
    background-color: #f2f2f2;
}

.grade tr:hover {
    background-color: #ddd;
}

.grade th {
    background-color: #e5e5e5;
}

#topicsScores .header th {
    background-color: #fff4ce !important;
    color: black !important;
}

#behaviorScores .header th {
    background-color: #ffe6fb !important;
    color: black !important;
}

#presenceScores .header th {
    background-color: #e7f8ef !important;
    color: black !important;
}

#reportNote .header th {
    background-color: #f5d9d4 !important;
    color: black !important;
}
</style>
